import axios from "axios";

const drw_endpoint_url = process.env.REACT_APP_LOCAL ? "http://localhost:8888" : "";

export type GetFeatureFlagSetParams = {
  key: string;
  // Launch Darkly defined type
  kind: "user";
  partnerCode: string;
  route: string;
}

export type GetFeatureFlagSetResponse = {
  disableGoogleNearbyRecommendations: boolean;
  enableChatBot: boolean;
  enableDRWTimeZone: boolean;
  enableGHRPromotion: boolean;
  enableLanguageOption: boolean;
  enableListViewForDestinationLocations: boolean;
  enablePartnerDetailsMethod: string;
  enablePepWalletCoupon: boolean,
  enablePredictiveETAInDRW: boolean;
  enableRescueTrackerChat: boolean;
  enableRescueTrackerStatusMethod: string;
  enableUrlShortener: boolean;
  omniStreamlined: string;
  pepPromotionFlag: string;
}

export const getFeatureFlagSetDRW = (payload: GetFeatureFlagSetParams): Promise<GetFeatureFlagSetResponse> => axios.post(`${drw_endpoint_url}/api/drw/featureSet/feature-flag-set`, payload);

export const getOmniStreamlinedDRW = (displayCode: string): Promise<string> => axios.get(`${drw_endpoint_url}/api/drw/partner/${displayCode}`);
